import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import React, { useEffect, useState } from "react";
import { gAPI_Invitation_By_Property } from "../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../helpers/AxiosAPI";
import ShowInvitations from './components/ShowInvitations';
import { Row } from 'reactstrap';
import no_invitations from '../../../../../assets/no_invitations.png';
function Invitations({ propertyId }) {
    const [invitationData, setInvitationData] = useState([]);
    const [isLoad, setIsLoad] = useState(true);
    useEffect(() => {
        if (isLoad) {
            LoadData();
            setIsLoad(false);
        }
    }, [propertyId, invitationData]);
    const LoadData = () => {
        AxiosAPI({
            url: `${gAPI_Invitation_By_Property}?group_id=${getGroupID()}&property_id=${propertyId}`,
            method: 'get',
        }).then((res) => {
            setInvitationData(res.data);
        })
            .catch((err) => console.log(err));
    };
    return (
        <div>
            {invitationData !== undefined && invitationData.length > 0 ?
                <ShowInvitations invitationData={invitationData}></ShowInvitations> :
                <div className="d-flex justify-content-center col-md-12"> <img onClick={() => window.location.href = "/app/pages/vouchers"} src={no_invitations} alt=""></img></div>
            }
        </div>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, currency } = settings;
    return {
        propertyId,
        locale,
        currency,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Invitations));
